<template>
    <div>
        <layout >
        <Search  slot="header-bar"   placeholder="请输入关键字搜索" v-model="search.input" @search="onRefresh">
            <div slot="left-icon">
                <button slot="left-icon" @click="statePanel=true"
                        style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">
                    {{prospectState}}
                </button>
                <!--<button slot="left-icon" @click="unitPanel=true"-->
                <!--style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">-->
                <!--{{unitName}}-->
                <!--</button>-->
            </div>
        </Search>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="margin-top:-5px;padding: 5px 12px"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <ProspectItem v-for="item in prospects" :key="item.id" :prospect="item"/>
            </List>
            <pf code="PROSPECT_TASK_ADD">
                <Icon name="plus" size="35px" color="#fff" @click="$router.push('/prospect/update')"
                      class="float-btn-add"/>
            </pf>
        </PullRefresh>
        </layout>
        <SelectTreePopup :show="unitPanel" :defaultSelected="search.unitId?{id:search.unitId,name:search.unitName}:{}"
                         :treeData="unitTree"
                         :defaultTitle="unitName" @ok="onUnitOk" @cancel="unitPanel = false"/>
        <SelectDict :showAll="true" dictKey="PROSPECT_TASK_STATE" :show="statePanel"
                    @ok="onStateOk" @cancel="statePanel=false"/>
    </div>
</template>

<script>
    import {Button, Icon, List, PullRefresh, Search} from "vant"
    import ProspectItem from "../components/ProspectItem";
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import SelectDict from "@/components/SelectPopup/SelectDict";
    import {mapGetters} from 'vuex'
    import {formatSearchData} from "@/utils/format";

    export default {
        components: {ProspectItem, Search, PullRefresh, List, Button, SelectTreePopup, SelectDict, Icon},
        props: {},
        data() {
            return {
                show: false,
                prospects: [],
                unitPanel: false,
                statePanel: false,
                search: {
                    unitId: null,
                    unitName: null,
                    input: null,
                    state: null,
                    stateName: null,
                },
                isReFresh: false,
                loading: false,
                finished: false
            }
        },
        computed: {
            ...mapGetters({unitTree: 'global/unitList'}),
            unitName() {
                return this.search.unitName || '选择单位'
            },
            prospectState() {
                return this.search.stateName || "全部"
            }
        },
        created() {
            this.$initUnit(this.search)
        },
        mounted() {
        },
        methods: {
            onStateOk(data) {
                this.search.stateName = data.codeName;
                if (data.code == "All") this.search.state = null;
                else this.search.state = data.code;
                this.onRefresh()
                this.statePanel = false;
            },
            onUnitOk(data) {
                this.unitPanel = false
                this.search.unitId = data.id
                this.search.unitName = data.name
                this.onRefresh()
            },
            onRefresh() {
                this.isReFresh = true;
                this.prospects = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                const data = {
                    position: this.search.input,
                    state: this.search.state,
                    unitId: this.$default.unitOrOrgan.id,
                    enableTaskDevice: true,// 启用加装设备
                    size: 20,
                    // page: this.prospects.length / 20 + 1
                }
                formatSearchData(data)
                this.$http.tokiot.prospect.task.list(data)
                    .then(res => {
                        if (res) {
                            this.prospects.push(...res.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            if (this.prospects.length >= res.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    .float-btn-add {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 28px;
        right: 20px;
        z-index: 999;
        background: #1988fa;
        border-radius: 50%;
        /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
    }

</style>